var React = require('react');

function TrainingProfileIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1524_5866)","key":0},React.createElement("path",{"d":"M9.99998 10.0007C11.8416 10.0007 13.3333 8.50898 13.3333 6.66732C13.3333 4.82565 11.8416 3.33398 9.99998 3.33398C8.15831 3.33398 6.66665 4.82565 6.66665 6.66732C6.66665 8.50898 8.15831 10.0007 9.99998 10.0007ZM9.99998 11.6673C7.77498 11.6673 3.33331 12.784 3.33331 15.0007V16.6673H16.6666V15.0007C16.6666 12.784 12.225 11.6673 9.99998 11.6673Z","fill":"#1A2B47"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1524_5866"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

TrainingProfileIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = TrainingProfileIcon;

TrainingProfileIcon.default = TrainingProfileIcon;
